<div class="modal-header mb-3">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="breeding-location.title"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm" class="form-horizontal">
        <div class="mb-3  row">
            <label for="locationName" class="col-sm-4 col-form-label text-start" jhiTranslate="breeding-location.field.location.name">Location Name</label>
            <div class="col-sm-6">
                <input type="text" class="form-control" name="locationName" [(ngModel)]="breedingLocation.name" [disabled]="!editable"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="abbreviation" class="col-sm-4 col-form-label text-start" jhiTranslate="breeding-location.field.code">Code</label>
            <div class="col-sm-6">
            <input type="text" class="form-control col-sm-6" name="abbreviation" [(ngModel)]="breedingLocation.abbreviation" [disabled]="!editable"/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="type" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-location.field.location.type">Location Type</label>
            <div class="col-sm-6">
                <input *ngIf="!editable" type="text" class="form-control col-sm-6" name="type" [value]="selectedLocationType?.name" disabled/>
                <select *ngIf="editable" class="form-select col-sm-6" name="type" [(ngModel)]="breedingLocation.type">
                    <option *ngFor="let locationType of locationTypes" [value]="locationType.id">
                        <label>{{locationType.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="parentLocId" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-location.field.parent.location">Parent Location</label>
            <div class="col-sm-6">
                <input *ngIf="!editable" type="text" class="form-control col-sm-6" name="country" [value]="breedingLocation.parentLocName" disabled/>
                <jhi-locations-select *ngIf="editable"
                                      [(value)]="breedingLocation.parentLocId"
                                      [showFilterOptions]="false"
                                      [showCountryField]="true"
                                      [disabled]="!editable">
                </jhi-locations-select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="country" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-location.field.country">Country</label>
            <div class="col-sm-6">
                <input *ngIf="!editable" type="text" class="form-control col-sm-6" name="country" [value]="selectedCountry?.name" disabled/>
                <select *ngIf="editable" class="form-select col-sm-6" name="country" [(ngModel)]="breedingLocation.countryId">
                    <option *ngFor="let country of countries" [value]="country.id">
                        <label>{{country.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <label for="abbreviation" class="col-sm-4 control-label control-label-left" jhiTranslate="breeding-location.field.geographical.details">Geographical Details</label>
            </div>
            <div class="col-sm-2">
                <input type="text" class="form-control col-sm-2 add_right_margin-10" name="latitude" [(ngModel)]="breedingLocation.latitude" [disabled]="!editable"/>
            </div>
            <div class="col-sm-2">
                <input type="text" class="form-control col-sm-2 add_right_margin-10" name="longitude" [(ngModel)]="breedingLocation.longitude" [disabled]="!editable"/>
            </div>
            <div class="col-sm-2">
                <input type="text" class="form-control col-sm-2 add_right_margin-10" name="altitude" [(ngModel)]="breedingLocation.altitude" [disabled]="!editable"/>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4"></div>
            <div class="col-sm-2"><em>{{"breeding-location.field.latitude" | translate}}</em></div>
            <div class="col-sm-2"><em>{{"breeding-location.field.longitude" | translate}}</em></div>
            <div class="col-sm-2"><em>{{"breeding-location.field.altitude" | translate}}</em></div>
        </div>
    </form>
</div>
